module.exports = __webpack_public_path__ + "static/img/useBox1.d954eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/useBox1.png
// module id = BK/O
// module chunks = 2